import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'apx-option',
    standalone: true,
    template: `
        <ng-content></ng-content>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApxDropdownOptionComponent {
    @Input() value!: string;
    @Input() label!: string;
}
